import { useReducer } from "react";

const estadoInicial = ({ revisionIdInicial, pasoInicial }) => ({
  revisionId: revisionIdInicial ?? null,
  informe: null, // Datos completos del informe. Null: mientras carga o si es nuevo
  cargando: Boolean(revisionIdInicial), // True: solo para informes existentes (por url) y aun no cargan sus datos
  pasoActivo: pasoInicial ?? 0,
});

function reducer(estado, accion) {
  switch (accion.type) {
    case 'EMPEZAR_CARGA':
      return { 
        ...estado, 
        cargando: true 
      };

    case 'ERROR_CARGA':
      return { 
        ...estado, 
        cargando:false 
      };

    // Carga inicial de un informe existente
    case 'REVISION_CARGADA':
      return { 
        ...estado,
        cargando: false,
        revisionId: accion.id,
        informe: accion.informe,
      };

    // Resultado de guardar un paso (1, 2 o 3).
    // Actualiza id, informe y paso activo
    case 'PASO_GUARDADO':
      return { 
        ...estado,
        cargando: false,
        revisionId: accion.id ?? estado.revisionId,
        informe: accion.informe,
        pasoActivo: accion.siguientePaso ?? estado.pasoActivo,
      };
  
    // Navegación manual del usuario entre los pasos (stepper)
    case 'CAMBIAR_PASO':
      return { 
        ...estado, 
        pasoActivo: accion.paso 
      };

    default:
      return estado;
  }
}

export function useInformeTallerState(revisionIdInicial, pasoInicial) {
  const [estado, dispatch] = useReducer(
    reducer,
    { revisionIdInicial, pasoInicial },
    estadoInicial,
  );

  return [estado, dispatch];
}

